const DEMO_BODY = `Hello MUNISVerse,

I would like to request a virtual tour demo.

Name:
Phone Number:
Location:

I am a:
[ ] Buyer
[ ] Tenant
[ ] Developer
[ ] Corporate
[ ] Estate Firm

Additional Information:

Thank you.`

const PARTNER_BODY = `Hello MUNISVerse,

I am interested in exploring a partnership with MUNISVerse.

Company Name:
Role/Position:
Location:

Type of Partnership:
[ ] Estate Firm
[ ] Developer
[ ] Corporate Housing
[ ] Shortlet Operations
[ ] Property Marketing
[ ] Other

Estimated Number of Properties:

Additional Information:

Thank you.`

const EMAIL = 'munisversehq@gmail.com'

function buildMailto(subject: string, body: string) {
  return `mailto:${EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export function openDemoMail() {
  window.location.href = buildMailto('Virtual Tour Demo Request', DEMO_BODY)
}

export function openPartnerMail() {
  window.location.href = buildMailto('Partnership Inquiry', PARTNER_BODY)
}
